import request from '@/utils/request'


export function goodsSta(query) {
  return request({
    url: '/statistics/goods/goods/page',
    method: 'post',
    headers:{"repeatSubmit": false},
    data: query
  })
}


export function goodsSalesPage(query) {
  return request({
    url: '/statistics/goods/sales/page',
    method: 'post',
    headers:{"repeatSubmit": false},
    data: query
  })
}

export function goodsSales(query) {
  return request({
    url: '/statistics/goods/goods/sales',
    method: 'get',
    params: query
  })
}

export function goodsCollection(query) {
  return request({
    url: '/statistics/goods/goods/collection',
    method: 'get',
    params: query
  })
}

export function goodsCart(query) {
  return request({
    url: '/statistics/goods/goods/cart',
    method: 'get',
    params: query
  })
}
export function cateSta(query) {
  return request({
    url: '/statistics/goods/cate/page',
    method: 'get',
    params: query
  })
}

export function skuSta(query) {
  return request({
    url: '/statistics/goods/sku/page',
    method: 'post',
    headers:{"repeatSubmit": false},
    data: query
  })
}


export function brandSta(query) {
  return request({
    url: '/statistics/goods/brand/page',
    method: 'get',
    params: query
  })
}

export function getGoodsRank(data) {
  return request({
    url: '/statistics/goods/user/rank',
    method: 'post',
    headers:{"repeatSubmit": false},
    data: data
  })
}

export function goodsCatePie(query) {
  return request({
    url: '/statistics/goods/cate/pie',
    method: 'get',
    params: query
  })
}

export function goodsCateAmountPie(query) {
  return request({
    url: '/statistics/goods/cate/amount/pie',
    method: 'get',
    params: query
  })
}

export function goodsBrowse(query) {
  return request({
    url: '/statistics/goods/goods/browse',
    method: 'get',
    params: query
  })
}